import React from "react";
import {createUseStyles, useTheme} from "react-jss";
import classNames from "classnames";
import PropTypes from "prop-types";
import * as R from "ramda";

import Container from "@components/Container";

const useStyles = createUseStyles(
  ({ rem }) => ({
    root: {
      width: "100%",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: [rem(10), rem(20)],
      color: "rgba(0, 0, 0, 1)"
    },
    title: {
      fontSize: rem(16),
      "& > span": {
        marginLeft: rem(20)
      }
    },
    introItem: {
      margin: 10,
      "& > img": {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: "50%"
      },
      "& > div": {
        marginLeft: 20,
        fontSize: rem(12),
        "& > p": {
          lineHeight: "15px",
          fontWeight: "bold",
          color: "rgba(38, 38, 38, 1)"
        },
        "& > span": {
          fontSize: rem(12),
          color: "#595959",
          letterSpacing: 1,
          lineHeight: "18px"
        }
      }
    }
  }),
  {
    name: "Material"
  }
);

// 原材料
const Material = props => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const { t, data } = props;
  const materialData = R.pathOr([], ["jsonData", "dcp1"])(data);
  let filterMeterialData = materialData.filter(item => {
    return item.base && item.base.name;
  });
  if (filterMeterialData.length === 0) {
    return null;
  }
  return (
    <Container className={classNames(classes.root)}>
      <Container flex alignItems="center" className={classes.title}>
        <img
          src="./static/images/products/icon_material.png"
          alt={t("raw")}
          height={40}
          width={40}
        />
        <span>{t("raw")}</span>
      </Container>
      {filterMeterialData.map((item, index) => {
        return (
          <Container
            flex
            direction="row"
            alignItems="center"
            className={classes.introItem}
            key={String(index)}
          >
            <img
              src={R.pathOr("", ["custom", "mainimage", "filelocation"])(item)}
              alt={R.pathOr(t("noData"), ["base", "name"])(item)}
            />
            <div>
              <p>{R.pathOr(t("noData"), ["base", "name"])(item)}</p>
              <span>
                {R.pathOr(t("noData"), ["custom", "description"])(item)}
              </span>
            </div>
          </Container>
        );
      })}
    </Container>
  );
};

Material.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired
};

export default Material;
